export const capitalizeWords = (str: string) => {
  return str
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const handleGoToFirstPage = (
  isMobile: boolean,
  goToFirstPage?: () => void
) => {
  if (!isMobile && goToFirstPage) {
    goToFirstPage();
  }
};
